import { Card, CardContent, CardHeader, CardTitle } from "@/ui/card";
import { Separator } from "@/ui/separator";
import { Skeleton } from "@/ui/skeleton";
import { Suspense } from "react";
import { LoginProviderLinks } from "./components/LoginProviderLinks";

export const LoginForm = () => {
  return (
    <Card className="w-full max-w-lg">
      <CardHeader>
        <CardTitle className="text-center text-base">
          Acessar Backoffice Detentora
        </CardTitle>
      </CardHeader>

      <Separator className="mb-6" />

      <CardContent className="flex flex-col gap-3">
        <Suspense
          fallback={
            <>
              <Skeleton className="h-12 w-full" />
              <Skeleton className="h-12 w-full" />
            </>
          }
        >
          <LoginProviderLinks />
        </Suspense>
      </CardContent>
    </Card>
  );
};
